(function () {
  'use strict';

  angular
    .module('services.translationService', ['services.sprintfService'])
    .factory('translationService', translationService);

  translationService.$inject = ['sprintfService', 'gettextCatalog', '$window', '$location'];

  function translationService(sprintfService, gettextCatalog, $window, $location) {

    // proxy cookie because we don't need to set it on the ipad??
//      var cookiesProxy = $window.$.cookie || $cookieStore;

    var domain = $location.host();
    var parts = domain.split('.');

    // set cookie to full domain
    if (parts.length > 2) {
      domain = parts.slice(-2).join('.');
    }


    var cookieStore = $window.$.cookie;
    var options = {
      domain: domain,
      path: '/',
      expires: new Date("Fri, 31 Dec 9999 23:59:59 GMT")
    };


    function sprintf() {
      var argv = [];
      for (var i = 0; i < arguments.length; i++) {
        argv.push(gettextCatalog.getString(arguments[i]));
      }

      try {
        return sprintfService.sprintf.apply(null, argv);
      } catch (err) {
        throw('sprintf error: ' + argv[0]);
      }
    }

    function selectedLanguage(value) {
      return cookieStore.call(null, 'selectedLanguage', value, options);
    }


    return {
      sprintf: sprintf,
      selectedLanguage: selectedLanguage
    };

  }

})();
